'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadMoreWP = function () {
	function LoadMoreWP(_ref) {
		var _ref$initialCount = _ref.initialCount,
		    initialCount = _ref$initialCount === undefined ? 6 : _ref$initialCount,
		    _ref$postType = _ref.postType,
		    postType = _ref$postType === undefined ? 'post' : _ref$postType,
		    wrapperSelector = _ref.wrapperSelector,
		    _ref$loadCount = _ref.loadCount,
		    loadCount = _ref$loadCount === undefined ? 6 : _ref$loadCount,
		    _ref$taxID = _ref.taxID,
		    taxID = _ref$taxID === undefined ? false : _ref$taxID,
		    _ref$taxType = _ref.taxType,
		    taxType = _ref$taxType === undefined ? false : _ref$taxType;

		_classCallCheck(this, LoadMoreWP);

		this.wrapperSelector = wrapperSelector;
		this.currentCount = initialCount;
		this.loadCount = loadCount;
		this.initialCount = initialCount;
		this.skipCount = initialCount;
		this.loadedOnce = false;
		this.taxID = taxID;
		this.taxType = taxType;
		this.getPosts();
	}

	_createClass(LoadMoreWP, [{
		key: 'getPosts',
		value: function getPosts(callback) {
			var _this = this;

			$.ajax('/wp-json/sms/v1/load-more?post-type=post&skip-count=' + this.skipCount + '&load-count=' + this.loadCount + (this.taxID && this.taxType ? '&taxID=' + this.taxID + '&taxType=' + this.taxType : '')).done(function (data) {
				_this.hasNextPosts = data.hasNextPosts;

				if (_this.$button && !data.hasNextPosts) {
					_this.destroyLoadMoreButton();
				}

				if (data.posts.length > 0) {
					_this.posts = data.posts;
					_this.brand = data.brand;
					_this.skipCount += _this.loadCount;

					if (!_this.loadedOnce) {
						_this.initLoadMoreButton();
					} else {
						if (callback) callback();
					}
				}
			}).fail(function (err) {
				return console.error('error', err);
			});
		}
	}, {
		key: 'initLoadMoreButton',
		value: function initLoadMoreButton() {
			var _this2 = this;

			$(this.wrapperSelector).after('\n\t\t\t<div class="sms-load-more">\n\t\t\t\t<div class="lds-ripple loader-hide"><div></div><div></div></div>\n\t\t\t\t<div class="btn-wrapper">\n\t\t\t\t\t<button class="btn btn-primary">Load More</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t');

			this.$button = $('.sms-load-more');
			this.$loader = this.$button.find('.lds-ripple');

			this.$button.find('.btn').on('click', function () {
				if (!_this2.loadedOnce) {
					_this2.loadPosts();
					_this2.loadedOnce = true;
					if (!_this2.hasNextPosts) _this2.destroyLoadMoreButton();
				} else {
					_this2.$loader.removeClass('loader-hide');
					_this2.getPosts(function () {
						return _this2.loadPosts();
					});
				}
			});
		}
	}, {
		key: 'destroyLoadMoreButton',
		value: function destroyLoadMoreButton() {
			var _this3 = this;

			this.$button.animate({
				opacity: 0
			}, 300, function () {
				return _this3.$button.remove();
			});
		}
	}, {
		key: 'loadPosts',
		value: function loadPosts() {
			var postsMarkup = '';

			for (var i = 0; i <= this.posts.length; i++) {
				var post = this.posts[i];
				if (post) {
					// Change markup per your design
					postsMarkup += '\n\t\t\t\t\t<article class="post-blog post-blog-nonprimary">\n\t\t\t\t\t\t<figure>\n\t\t\t\t\t\t\t' + this.renderCustomFeaturedImage(post) + '\n\t\t\t\t\t\t\t<figcaption>\n\t\t\t\t\t\t\t\t' + (post.category ? '<h5>' + post.category + '</h5>' : '') + '\n\t\t\t\t\t\t\t\t<h3><a href="' + post.permalink + '">' + post.post_title + '</a></h3>\n\t\t\t\t\t\t\t</figcaption>\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t</article>\n\t\t\t\t';
				}
			}
			$(this.wrapperSelector).append(postsMarkup);
			this.$loader.addClass('loader-hide');
		}
	}, {
		key: 'renderAuthor',
		value: function renderAuthor(author) {
			if (author) {
				return '\n\t\t\t\t<p class="blog-item-author"><i class="fa fa-pencil"></i> ' + author + '</p>\n\t\t\t';
			} else return '';
		}
	}, {
		key: 'renderCustomFeaturedImage',
		value: function renderCustomFeaturedImage(post) {
			var src = post.acf.post_featured_image_small ? post.acf.post_featured_image_small : post.acf.featured_image_desktop_marquee;

			if (!src) src = this.brand.defaultMarquee.desktop;

			return '\n\t\t\t<a href="' + post.permalink + '" class="img-wrapper">\n\t\t\t\t<img src=\'' + src + '\' alt=\'featured image of post: ' + post.post_title + '\'/>\n\t\t\t</a>\n\t\t';
		}
	}]);

	return LoadMoreWP;
}();